<script setup lang="ts">
import Toast from 'primevue/toast'
</script>

<template>
  <RouterView />
  <Toast />
</template>
